import { downloadExcel } from "react-export-table-to-excel";
export default function handleDownloadExcel({
  filename,
  tableBody,
  tableHeader,
}) {
  downloadExcel({
    fileName: filename,
    sheet: "Page1",
    tablePayload: {
      header: tableHeader,
      body: tableBody,
    },
  });
}
